/* eslint-disable camelcase */
import Service from './service';

const Config = require('Config');

export type AutoCompleteSuggestion = {
  name: string;
  client_name: string;
  client_number: string;
  mc_number: number;
};

class InternalService extends Service {
  constructor() {
    super(Config.internalServiceUrl);
  }

  getClientAutoComplete(searchText): Promise<AutoCompleteSuggestion[]> {
    const encodedSearchText = encodeURIComponent(searchText);
    // eslint-disable-next-line max-len
    const url = `client-autocomplete/?searchValue=${encodedSearchText}&limit=100&leftAnchored=true&includeMCNumber=true`;
    return this.axios.get(url).then((response) => {
      const fullData = response.data;
      const returnedSuggestions = [];
      // If MC number is null we need to make it an empty string and AutcompleteTextField expects suggestion.name
      fullData.forEach(element => {
        const newMC = element.mc_number !== null ? element.mc_number : '';
        returnedSuggestions.push({...element, name: element.client_name, mc_number: newMC});
      });
      const sortedReturn = returnedSuggestions.sort((a, b) => {
        const lowerA = a.name.toLowerCase();
        const lowerB = b.name.toLowerCase();
        if (lowerA < lowerB) {
          return -1;
        }
        if (lowerA > lowerB) {
          return 1;
        }
        return 0;
      });
      return Promise.resolve(sortedReturn);
    });
  };
}

export default new InternalService();
